function requires() {
  const stripCss = url => {
    return url.endsWith(".css") ? url.substring(0, url.length - 4) : url;
  };

  const dep = {};
  const dependencies = window.configuration;
  const getModule = (lib, name) => {
    const urls = {};

    const dependencies = window.configuration;
    const dependency = dependencies[lib];

    const module = lib.replace("@unimed/", "");

    urls[`${name || module}css`] = stripCss(`/static/${dependency.css}`);
    urls[`${name || module}js`] = `/static/${dependency.js}`;

    return urls;
  };

  Object.keys(dependencies).forEach(dependency => {
    Object.assign(dep, getModule(dependency));
  });

  global.requirejs.config({
    waitSeconds: 180,
    map: {
      "*": {
        css: "/require-css/css.js",
        ...getModule("@unimed/amc", "movimentacao"),
        ...getModule("@unimed/atd-adm", "atd"),
        ...getModule("@unimed/atd-adm", "atendimento"),
        ...getModule("@unimed/taric-adm", "taric"),
        ...getModule("@unimed/aut", "autorizador"),
        ...getModule("@unimed/cad", "administracao"),
        ...getModule("@unimed/cad", "adm"),
        ...dep
      }
    }
  });
}

export default requires;
